@if (serviceRequired) {
  <span [title]="'Helmsmen on arrival at ' + nextBerthName" class="text-muted">
    <span class="fa fa-fw fa-dharmachakra me-1"></span>{{service.serviceProvider?.name}}
  </span>
}
